import { BaseModalComponent } from './../base/base-modal.component';
import { EMAIL_REGEX, PHONE_REGEX } from './../../../../../shared/regular-expressions/regex';
import { FormGenModel } from './../../../../../shared/models/form-gen.model';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { ModalController, NavParams } from '@ionic/angular';
import { setValidators } from '../../../../../shared/validators/set-validators';

export const CONTACT_LIST: FormGenModel[] = [
  { label: 'NAME', value: 'name' },
  { label: 'PHONE', value: 'phone' },
  { label: 'EMAIL', value: 'email' }
];

export function getContactFormGroup(contactForm?: FormGroup): FormGroup {
  return new FormGroup({
    name: new FormGroup({
      use: new FormControl('official'),
      prefix: new FormArray([
        new FormControl('')
      ]),
      family: new FormControl(''),
      given: new FormArray([
        new FormControl('')
      ]),
      suffix: new FormArray([
        new FormControl('')
      ]),
      text: new FormControl(contactForm ? contactForm.value.name : '')
    }),
    telecom: new FormArray([
      new FormGroup({
        system: new FormControl('EMAIL'),
        value: new FormControl(contactForm ? contactForm.value.email : ''),
        rank: new FormControl(1)
      }),
      new FormGroup({
        system: new FormControl('PHONE'),
        value: new FormControl(contactForm ? contactForm.value.phone : ''),
        rank: new FormControl(2)
      })
    ])
  });
}

@Component({
  selector: 'inc-contact',
  templateUrl: './../base/base-modal.component.html'
})
export class ContactComponent extends BaseModalComponent implements OnInit {
  title = 'CONTACT_PERSON';
  formGenList = CONTACT_LIST;

  constructor(modalController: ModalController, private navParams: NavParams) {
    super(modalController);
    this.reset(new FormGroup({
      name: new FormControl('', Validators.compose([Validators.required])),
      email: new FormControl('', Validators.compose([Validators.pattern(EMAIL_REGEX)])),
      phone: new FormControl('', Validators.compose([Validators.pattern(PHONE_REGEX)]))
    }));
  }

  ngOnInit() {
    super.ngOnInit();
    const extraValidators = this.navParams.get('extraValidators');
    if (extraValidators) { this.form = setValidators(this.form, extraValidators); }
  }

  save() {
    this.baseSave({ value: { contact: getContactFormGroup(this.form) } });
  }
}
